import { render, staticRenderFns } from "./PMarkdown.vue?vue&type=template&id=7078ed03&"
import script from "./PMarkdown.vue?vue&type=script&lang=js&"
export * from "./PMarkdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports